// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.estoqueLogistica{
    width: 100%;
    z-index: 5;
}

.estoqueLogistica .listaEstoqueItens{
    width: 96%;
    display: grid;
    grid-template-columns: 25% 25% 25%;
    gap: 30px 5%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5% 2%;
}

.estoqueLogistica .itemEstoque{
    display: flex;
    flex-direction: column;
    padding: 5%;
    border-radius: 15px;
    border: 2px solid var(--medio-azul-marin-color);
    background-color: var(--white-color);
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
}

.estoqueLogistica .itemEstoque .fotoProd{
    width: 30%;
    aspect-ratio: 2 / 3;
    margin: 0 auto 10px auto;
}

.estoqueLogistica .itemEstoque .revNome{
    text-align: center;
    font-weight: 800;
    margin-bottom: 5px;
}

.estoqueLogistica .itemEstoque .itemTmPg{
    display: flex;
    justify-content: space-between;
}

.estoqueLogistica .itemEstoque .itemQuantd{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}


.estoqueLogistica .itemEstoque .itemQuantd > div{
    flex: 1 1 30%;
    margin: 0 1% 8px 1%;
    padding: 5px;
    background-color: var(--escuro-azul-color);
    color: var(--white-color);
    text-align: center;
}



/* FILTRO */
.estoqueLogistica input {
    background-color: var(--white-color);
    width: fit-content;
    margin-bottom: 3%;
    color: #000000;
    font-size: 15px;
    border-radius: 7px;
    padding: 10px;
    border: 1.5px solid #dededf;
  }
  
  .estoqueLogistica input:is(:focus, :hover){
    border-color: rgba(100, 158, 234, 0.4);
    background-color: #fff;
    box-shadow: 0 0 0 4px #649eea1a;
    outline: none;
  }
  .filtroEstoqueLogisitca{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    background-color: var(--white-color);
    padding-top: 50px;
    height: 100%;
  }

  .estoqueLogistica .btnShowFiltroEstoque, .estoqueLogistica .btnShowAtualizaEstoque{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
    margin: 10px auto 10px auto;
    cursor: pointer;
    font-size: 1.2em;
    font-family: 'Cardo-Bold', 'sans-serif';
    border: 2px solid var(--escuro-azul-color);
    color: var(--escuro-azul-color);
    background-color: var(--white-color);
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
}


.estoqueLogistica .ultimaAtt{
    font-size: 1.5em;
    font-family: 'Cardo-Bold', 'sans-serif';
    color: var(--escuro-azul-color);
    text-align: center;
}

@media(max-width: 767px){

    .estoqueLogistica .listaEstoqueItens{
        grid-template-columns: 100%;
        width: 100%;
    }


    .estoqueLogistica .itemEstoque .fotoProd{
        width: 100%;
        aspect-ratio: 2 / 3;
        margin: 0 auto 10px auto;
    }
    

    

}`, "",{"version":3,"sources":["webpack://./src/assets/css/estoqueLogistica.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,kCAAkC;IAClC,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,+CAA+C;IAC/C,oCAAoC;IACpC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;AACtB;;;;AAIA,WAAW;AACX;IACI,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;IACtC,sBAAsB;IAEtB,+BAA+B;IAC/B,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,0CAA0C;IAC1C,+BAA+B;IAC/B,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;;IAEI;QACI,2BAA2B;QAI3B,WAAW;IAHf;;;IAOA;QACI,WAAW;QACX,mBAAmB;QACnB,wBAAwB;IAC5B;;;;;AAKJ","sourcesContent":[".estoqueLogistica{\r\n    width: 100%;\r\n    z-index: 5;\r\n}\r\n\r\n.estoqueLogistica .listaEstoqueItens{\r\n    width: 96%;\r\n    display: grid;\r\n    grid-template-columns: 25% 25% 25%;\r\n    gap: 30px 5%;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 5% 2%;\r\n}\r\n\r\n.estoqueLogistica .itemEstoque{\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 5%;\r\n    border-radius: 15px;\r\n    border: 2px solid var(--medio-azul-marin-color);\r\n    background-color: var(--white-color);\r\n    font-family: 'Roboto', sans-serif;\r\n    font-weight: 700;\r\n}\r\n\r\n.estoqueLogistica .itemEstoque .fotoProd{\r\n    width: 30%;\r\n    aspect-ratio: 2 / 3;\r\n    margin: 0 auto 10px auto;\r\n}\r\n\r\n.estoqueLogistica .itemEstoque .revNome{\r\n    text-align: center;\r\n    font-weight: 800;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.estoqueLogistica .itemEstoque .itemTmPg{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.estoqueLogistica .itemEstoque .itemQuantd{\r\n    width: 100%;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 10px;\r\n}\r\n\r\n\r\n.estoqueLogistica .itemEstoque .itemQuantd > div{\r\n    flex: 1 1 30%;\r\n    margin: 0 1% 8px 1%;\r\n    padding: 5px;\r\n    background-color: var(--escuro-azul-color);\r\n    color: var(--white-color);\r\n    text-align: center;\r\n}\r\n\r\n\r\n\r\n/* FILTRO */\r\n.estoqueLogistica input {\r\n    background-color: var(--white-color);\r\n    width: fit-content;\r\n    margin-bottom: 3%;\r\n    color: #000000;\r\n    font-size: 15px;\r\n    border-radius: 7px;\r\n    padding: 10px;\r\n    border: 1.5px solid #dededf;\r\n  }\r\n  \r\n  .estoqueLogistica input:is(:focus, :hover){\r\n    border-color: rgba(100, 158, 234, 0.4);\r\n    background-color: #fff;\r\n    -webkit-box-shadow: 0 0 0 4px #6488ea1a;\r\n    box-shadow: 0 0 0 4px #649eea1a;\r\n    outline: none;\r\n  }\r\n  .filtroEstoqueLogisitca{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 1000;\r\n    background-color: var(--white-color);\r\n    padding-top: 50px;\r\n    height: 100%;\r\n  }\r\n\r\n  .estoqueLogistica .btnShowFiltroEstoque, .estoqueLogistica .btnShowAtualizaEstoque{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 40%;\r\n    margin: 10px auto 10px auto;\r\n    cursor: pointer;\r\n    font-size: 1.2em;\r\n    font-family: 'Cardo-Bold', 'sans-serif';\r\n    border: 2px solid var(--escuro-azul-color);\r\n    color: var(--escuro-azul-color);\r\n    background-color: var(--white-color);\r\n    padding: 10px 20px;\r\n    text-align: center;\r\n    border-radius: 5px;\r\n}\r\n\r\n\r\n.estoqueLogistica .ultimaAtt{\r\n    font-size: 1.5em;\r\n    font-family: 'Cardo-Bold', 'sans-serif';\r\n    color: var(--escuro-azul-color);\r\n    text-align: center;\r\n}\r\n\r\n@media(max-width: 767px){\r\n\r\n    .estoqueLogistica .listaEstoqueItens{\r\n        grid-template-columns: 100%;\r\n    }\r\n\r\n    .estoqueLogistica .listaEstoqueItens{\r\n        width: 100%;\r\n    }\r\n\r\n\r\n    .estoqueLogistica .itemEstoque .fotoProd{\r\n        width: 100%;\r\n        aspect-ratio: 2 / 3;\r\n        margin: 0 auto 10px auto;\r\n    }\r\n    \r\n\r\n    \r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
